(function () {
  function safeFbq(name, params) {
    if (typeof fbq === 'function') fbq('trackCustom', name, params || {});
  }

  let activeTime = 0;
  let scrolledToProducts = false;
  let timeOnPage15Fired = false;
  let qualifiedScrollFired = false;
  let timerInterval = null;

  const productGridTargets = [
    document.querySelector('fc-product-slider'),
    document.querySelector('.product-grid')
  ].filter(Boolean);

  function checkQualifiedScroll() {
    if (!qualifiedScrollFired && scrolledToProducts && activeTime >= 10) {
      qualifiedScrollFired = true;
      safeFbq('QualifiedScroll');
    }
  }

  function startTimer() {
    if (timerInterval) return;
    timerInterval = setInterval(function () {
      activeTime++;
      if (!timeOnPage15Fired && activeTime >= 15) {
        timeOnPage15Fired = true;
        safeFbq('TimeOnPage15');
      }
      checkQualifiedScroll();
      if (timeOnPage15Fired && (qualifiedScrollFired || !productGridTargets.length)) {
        clearInterval(timerInterval);
        timerInterval = null;
      }
    }, 1000);
  }

  function stopTimer() {
    clearInterval(timerInterval);
    timerInterval = null;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      stopTimer();
    } else {
      startTimer();
    }
  });

  startTimer();

  if (productGridTargets.length && 'IntersectionObserver' in window) {
    const scrollObserver = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; }) && !scrolledToProducts) {
        scrolledToProducts = true;
        safeFbq('ScrollDepth_Product');
        scrollObserver.disconnect();
        checkQualifiedScroll();
      }
    }, { threshold: 0.1 });
    productGridTargets.forEach(function (t) { scrollObserver.observe(t); });
  }

  if (window.location.pathname.indexOf('/products/') !== -1) {
    let imageEngageFired = false;

    function fireImageEngage() {
      if (!imageEngageFired) {
        imageEngageFired = true;
        safeFbq('ProductImageEngage');
      }
    }

    const gallery = document.querySelector('media-gallery');
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        if (e.target.closest('.slider-button, .thumbnail-list__item')) {
          fireImageEngage();
        }
      });

      let touchStartX = 0;
      const mediaList = gallery.querySelector('.product__media-list');
      if (mediaList) {
        mediaList.addEventListener('touchstart', function (e) {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        mediaList.addEventListener('touchend', function (e) {
          if (Math.abs(e.changedTouches[0].clientX - touchStartX) > 50) {
            fireImageEngage();
          }
        }, { passive: true });
      }
    }
  }

  if (window.location.pathname.indexOf('/products/') !== -1) {
    const VIEWED_KEY = 'lunesi_px_viewed';
    const FIRED_KEY = 'lunesi_px_2nd_fired';

    if (!sessionStorage.getItem(FIRED_KEY)) {
      const handle = window.location.pathname.split('/products/')[1].split(/[?/#]/)[0];
      let viewed = [];
      try {
        viewed = JSON.parse(sessionStorage.getItem(VIEWED_KEY) || '[]');
      } catch (e) {
        viewed = [];
      }
      if (viewed.indexOf(handle) === -1) {
        viewed.push(handle);
        sessionStorage.setItem(VIEWED_KEY, JSON.stringify(viewed));
      }
      if (viewed.length >= 2) {
        sessionStorage.setItem(FIRED_KEY, '1');
        setTimeout(function () { safeFbq('SecondProductView'); }, 500);
      }
    }
  }
})();
